var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('div',{staticClass:"reg"},[_c('h3',[_vm._v("用户注册")]),_c('UserRegisterForm',{attrs:{"inviteKey":_vm.inviteKey}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }